import { Field, getIn, useFormikContext } from 'formik';
import React, { useCallback, useEffect } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import { FormikCheckBox } from '../../../components';

export default function SummaryWarning({ setModalActionParams }) {
  const { values } = useFormikContext();
  const scheduleValue = getIn(values, 'settlement.scheduleDeactivationTask');
  const scheduleDeactivationTask = !!(scheduleValue === 'true' || scheduleValue);
  const updateCurrentValues = useCallback(() => {
    setModalActionParams(oldValues => ({
      ...oldValues,
      values: {
        ...oldValues.values,
        settlement: {
          ...oldValues.values.settlement,
          scheduleDeactivationTask
        }
      }
    }));
  }, [setModalActionParams, scheduleDeactivationTask]);
  useEffect(updateCurrentValues, [scheduleDeactivationTask, updateCurrentValues]);
  return (
    <Modal.Body>
      <Row>
        <p>
          <strong>
            Si usted desea que el término de contrato se realice automáticamente en la fecha de término del finiquito,
            presione el siguiente botón y confirme. En caso contrario, solo presione confirmar.
          </strong>
        </p>
        <Col md={12}>
          <Field name="settlement[scheduleDeactivationTask]">
            {({ field }) => (
              <FormikCheckBox
                {...field}
                field={field}
                label={
                  !scheduleDeactivationTask
                    ? 'No realizar desactivación automática'
                    : 'Realizar desactivación automática'
                }
                custom
                type="switch"
              />
            )}
          </Field>
        </Col>
      </Row>
    </Modal.Body>
  );
}
